// Builds ONE Excel workbook (a sheet per selected test) and downloads it, plus each test's graph as a PNG.
import { TESTS } from './testRegistry';

const saveBlob = (blob, name) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
};
const pause = (ms) => new Promise((r) => setTimeout(r, ms));

export async function downloadReport({ header, tests }) {
  const { default: ExcelJS } = await import('exceljs');
  const wb = new ExcelJS.Workbook();
  wb.creator = header.testedBy || 'Lab';

  const extra = [];
  for (const t of TESTS) {
    if (!tests[t.id] || !t.exporter) continue;
    extra.push(...((await t.exporter.addSheet(wb, { header, data: tests[t.id] })) || []));
  }

  const base = `${header.sampleNo || 'Sample'}_Ch_${header.location || ''}`.replace(/[^A-Za-z0-9.+-]+/g, '_');
  const buf = await wb.xlsx.writeBuffer();
  saveBlob(new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `${base}.xlsx`);
  for (const f of extra) {
    await pause(400); // browsers ask permission for extra automatic downloads; a short gap keeps it reliable
    saveBlob(f.blob, `${base}_${f.suffix}`);
  }
}
